import { render, staticRenderFns } from "./Vacco.vue?vue&type=template&id=2d004bd5&"
import script from "./Vacco.vue?vue&type=script&lang=js&"
export * from "./Vacco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports